import { Router } from '@angular/router';
import { parse } from 'query-string';
import * as URL from 'url-parse';
import { WindowService } from '../window/window.service';
var ReturnUrlService = /** @class */ (function () {
    function ReturnUrlService(router, windowService) {
        this.router = router;
        this.windowService = windowService;
        this.returnUrlKey = 'returnUrl';
    }
    Object.defineProperty(ReturnUrlService.prototype, "sessionStorage", {
        get: function () {
            return this.windowService.sessionStorage;
        },
        enumerable: true,
        configurable: true
    });
    ReturnUrlService.prototype.navigate = function () {
        var returnUrl = this.load();
        if (returnUrl) {
            var url = URL(returnUrl);
            var commands = url.pathname.split('/').filter(function (i) { return i; });
            var queryParams = parse(url.query);
            // noinspection JSIgnoredPromiseFromCall
            this.router.navigate(commands, {
                queryParams: queryParams
            });
        }
        else {
            // noinspection JSIgnoredPromiseFromCall
            this.router.navigate(['home']);
        }
    };
    // Stash the 'returnUrl' so it can be reinstated after we get called back to.
    ReturnUrlService.prototype.save = function () {
        var returnUrl = this.windowService.window.location.href;
        this.windowService.localStorage.setItem(this.returnUrlKey, returnUrl);
    };
    ReturnUrlService.prototype.clear = function () {
        this.windowService.localStorage.removeItem(this.returnUrlKey);
    };
    ReturnUrlService.prototype.load = function () {
        return this.windowService.localStorage.getItem(this.returnUrlKey);
    };
    return ReturnUrlService;
}());
export { ReturnUrlService };
